import { getLocalStorageObject } from '../../localstorage/localStorage';
import { LocalStorageKeys } from '../../localstorage/constants';

export const useAuthToken = () => getLocalStorageObject(LocalStorageKeys.AuthToken);
